import script from "./ContributorOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributorOverview.vue?vue&type=script&setup=true&lang=js"

import "./ContributorOverview.vue?vue&type=style&index=0&id=2e402794&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e402794"]])

export default __exports__